module.exports = __webpack_public_path__ + "static/laptop-404-7af38dbc227f40b54e68c065ea1c3879.svg";